import FirmwareVersion from './FirmwareVersion'

export default FirmwareVersion
